export enum VotingAction {
  UPVOTED = 'upvoted',
  DOWNVOTED = 'downvoted',
  REMOVED_UPVOTE = 'removed_upvote',
  REMOVED_DOWNVOTE = 'removed_downvote',
}
